import { GridColumnProps } from '@roc/client-portal-shared/components';
import { statusProperties } from '@roc/client-portal-shared/utils';
import { formatCurrency } from '@roc/ui/utils';
import { tooltips } from '@roc/feature-loans-shared';
import { loanPriorityOptions } from '@roc/feature-loans';
import { tooltipHeaderTemplate } from '@roc/client-portal-shared/components';

const usdAmount: any = params => {
  return params.value && formatCurrency(Number(params.value));
};

const noOpComparator = () => 0;

export const myPipelineLoansColumns: GridColumnProps[] = [
  {
    field: 'dealid',
    headerName: 'Loan Id',
    maxWidth: 110,
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    pinned: 'left',
    lockPinned: true,
  },
  {
    field: 'underwritingPendingDocuments',
    headerName: 'Underwriting Pending Documents',
    minWidth: 70,
    maxWidth: 320,
    cellRenderer: 'pendingDocumentsCellRenderer',
    comparator: noOpComparator,
  },
  {
    field: 'closingPendingDocuments',
    headerName: 'Closing Pending Documents',
    minWidth: 70,
    maxWidth: 300,
    cellRenderer: 'pendingDocumentsCellRenderer',
    comparator: noOpComparator,
  },
  {
    field: 'dealName',
    headerName: 'Deal Name',
    minWidth: 300,
    cellRenderer: 'dealNameCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 150,
    cellRenderer: 'statusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Agreed', value: 'AGREED' },
        { label: 'Deal Room', value: 'DEAL_ROOM' },
        { label: 'In Underwriting', value: 'IN_UNDERWRITING' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
        { label: 'Pending Term Sheet', value: 'PENDING_TERM_SHEET' },
        { label: 'Pre-Submission', value: 'PENDING_SUBMISSION' },
        { label: 'Prescreen', value: 'PRESCREEN' },
        { label: 'Term Sheet Out', value: 'TERM_SHEET_OUT' },
        { label: 'Unknown', value: 'UNKNOWN' },
      ],
    },
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Type',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Amount',
    minWidth: 125,
    valueFormatter: usdAmount,
    comparator: noOpComparator,
  },
  {
    field: 'fastrackPaymentComplete',
    headerName: 'Fast Tracked Loan',
    minWidth: 125,
    cellRenderer: 'fastTrackCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraisalReportUploaded',
    headerName: 'Appraisal Report Uploaded',
    minWidth: 125,
    cellRenderer: 'appraisalReportUploadedCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraisalPaid',
    headerName: 'Appraisal Paid',
    minWidth: 125,
    cellRenderer: 'appraisalPaidCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'interestEconomics',
    headerName: 'Interest Economics',
    minWidth: 200,
    comparator: noOpComparator,
    headerTooltip: tooltips.interestEconomics,
    headerComponentParams: {
      template: tooltipHeaderTemplate,
    },
  },
  {
    field: 'keyRatios',
    headerName: 'Key Ratios',
    minWidth: 200,
    comparator: noOpComparator,
    headerTooltip: tooltips.keyRatios,
    headerComponentParams: {
      template: tooltipHeaderTemplate,
    },
  },
  {
    field: 'borrowerSubmission',
    headerName: 'Borrower Submission',
    minWidth: 200,
    cellRenderer: 'borrowerSubmissionCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'submittedBy',
    headerName: 'Submitted By',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'coordinator',
    headerName: 'Processor',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'underwriter',
    headerName: 'Underwriter',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'priority',
    headerName: 'Priority',
    minWidth: 100,
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: loanPriorityOptions,
    },
  },
  {
    field: 'lenderOriginatorName',
    headerName: 'Originator',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    }
  },
  {
    field: 'manualQuoteDescription',
    headerName: 'Manual Quote',
    minWidth: 125,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    }
  },
  {
    headerName: 'Action',
    minWidth: 80,
    cellRenderer: 'actionCellRenderer',
    comparator: noOpComparator,
    width: 80,
    pinned: 'right',
    lockPinned: true
  },
];

export const myDraftLoansColumns: GridColumnProps[] = [
  {
    field: 'borrowers',
    headerName: 'Borrowers',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanType',
    headerName: 'Loan Type',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Subtype',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Amount',
    minWidth: 130,
    valueFormatter: usdAmount,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'originatorName',
    headerName: 'Originator',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    }
  },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    minWidth: 125,
    comparator: noOpComparator,
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    headerName: 'Action',
    minWidth: 80,
    cellRenderer: 'actionCellRenderer',
    comparator: noOpComparator,
    width: 80,
    pinned: 'right',
    lockPinned: true
  },
]

export const myQuoteLoansColumns: GridColumnProps[] = [
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 300,
    cellRenderer: 'propertyAddressCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'borrowers',
    headerName: 'Borrowers',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 150,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    }
  },
  {
    field: 'loanAmount',
    headerName: 'Amount',
    valueFormatter: usdAmount,
    minWidth: 125,
    comparator: noOpComparator,
  },
  {
    field: 'type',
    headerName: 'Type',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    headerName: 'Action',
    minWidth: 80,
    cellRenderer: 'actionCellRenderer',
    comparator: noOpComparator,
    width: 80,
    pinned: 'right',
    lockPinned: true
  },
]

export const myRequestLoansColumns: GridColumnProps[] = [
  {
    field: 'dealName',
    headerName: 'Deal Name',
    minWidth: 400,
    cellRenderer: 'dealNameRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Type',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'originatorName',
    headerName: 'Originator',
    minWidth: 150,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    minWidth: 125,
    comparator: noOpComparator,
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    minWidth: 150,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'key',
    headerName: 'Action',
    cellRenderer: 'actionCellRenderer',
    comparator: noOpComparator,
    width: 80,
    pinned: 'right',
    lockPinned: true,
    equals: () => false,
  },
];


export const myPendingApprovalLoansColumns: GridColumnProps[] = [
  {
    field: 'borrowers',
    headerName: 'Borrowers',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanType',
    headerName: 'Loan Type',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Subtype',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Amount',
    minWidth: 130,
    valueFormatter: usdAmount,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'originatorName',
    headerName: 'Originator',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    }
  },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    minWidth: 125,
    comparator: noOpComparator,
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 130,
    cellRenderer: 'statusCellRenderer',
    comparator: noOpComparator,
  },
];
export const myAgreedLoansColumns: GridColumnProps[] = [
  {
    field: 'dealid',
    headerName: 'Loan Id',
    minWidth: 100,
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    pinned: 'left',
    lockPinned: true,
  },
  {
    field: 'dealName',
    headerName: 'Deal Name',
    minWidth: 300,
    cellRenderer: 'dealNameCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Type',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'attorney',
    headerName: 'Attorney',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Amount',
    minWidth: 125,
    valueFormatter: usdAmount,
    comparator: noOpComparator,
  },
  {
    field: 'pendingClosingConditions',
    headerName: 'Closing Conditions',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    cellRenderer: 'pendingClosingConditionsCellRenderer',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'expectedClosingDate',
    headerName: 'Expected Closing Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'expectedWireReleaseDate',
    headerName: 'Expected Wire Release Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'fastrackPaymentComplete',
    headerName: 'Fast Tracked Loan',
    minWidth: 125,
    cellRenderer: 'fastTrackCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'insuranceApprovedStatus',
    headerName: 'Insurance Approved Status',
    minWidth: 125,
    cellRenderer: 'insuranceApprovedCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'closingDocsStatus',
    headerName: 'Closing Docs Status',
    cellRenderer: 'closingDocsCellRenderer',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'hudStatus',
    headerName: 'HUD Status',
    cellRenderer: 'hudStatusCellRenderer',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'finalLoanApprovalStatus',
    headerName: 'Loan Approval Status',
    minWidth: 300,
    cellRenderer: 'loanApprovalCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'achConsentFormStatus',
    headerName: 'ACH Status',
    cellRenderer: 'achStatusCellRenderer',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'wireRequested',
    headerName: 'Wire Requested',
    minWidth: 300,
    cellRenderer: 'wireRequestedCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
];
